// extracted by mini-css-extract-plugin
export default {"sparks":"GreenSparks_sparks__tg-Fz","spark":"GreenSparks_spark__g3twD","floatSpark":"GreenSparks_floatSpark__ZxFQk"};